export const sharedAdvancedSearchFiltersStyles = {
  panelPaper: {
    pt: 2,
    mb: 1,
    backgroundColor: '#fafafa',
  },
  autocompleteField: {
    width: '100%',
  },
  datePickerTextField: {
    "& .MuiInputBase-root": {
      height: "30px",
      minHeight: "30px",
      maxHeight: "30px",
      backgroundColor: "transparent",
      overflow: "visible",
      border: "none !important",
      borderBottom: "1px solid #d1d5db",
    },
  },
  actionButtonsContainer: {
    display: 'flex',
    gap: 2,
    justifyContent: 'flex-end',
    mt: 1,
  },
  clearButton: {
    textTransform: 'none',
    borderColor: '#d1d5db',
    color: '#6b7280',
    '&:hover': {
      borderColor: '#9ca3af',
      backgroundColor: '#f9fafb',
    },
  },
  applyButton: {
    textTransform: 'none',
    backgroundColor: '#3b82f6',
    '&:hover': {
      backgroundColor: '#2563eb',
    },
  },
};
